/* eslint-disable */
import React, { useMemo, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {where} from 'firebase/firestore';
import { useWorker } from '../../contexts/WorkerContext';
import WorkerCasesList from '../../components/WorkerComponents/WorkerCasesListComponent';
import WorkerValuationsList from '../../components/WorkerComponents/WorkerValuationListComponent';
import useFetchData from '../../hooks/ValuatorHooks/useFetchData';
import '../../Styles/ValuatorStyles/WorkerDetailsPage.css';
import ValuateNavbar from '../../components/ValuatorNavbar';
import LoadingComponent from '../../components/LoadingComponent';
import { groupCasesByMonth, calculateAverageRatingsByMonth } from '../../utilities/caseUtils';
import MonthPicker from '../../components/MonthlyReportComponents/MonthPicker';
import { useSelectedCompany } from '../../contexts/SelectedCompanyContext';
import useFetchCompanyId from '../../hooks/CompanyHooks/useFetchCompanyId';

const WorkerDetailsPage = () => {
  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const { selectedCompany } = useSelectedCompany();
  const { companyId } = useFetchCompanyId(selectedCompany);
  const { workerId } = useParams();
  
  const { currentWorker, setCurrentWorker } = useWorker();
  const casesQuery = useMemo(() => [where('attachedWorkers', 'array-contains', workerId)], [workerId]);
  const valuationsQuery = useMemo(() => [where('attachedWorkers', 'array-contains', workerId)], [workerId]);
  const [groupedCases, setGroupedCases] = useState({});
  const [averageRatings, setAverageRatings] = useState({});
  
  const { data: workerCases, loading: casesLoading, error: casesError } = useFetchData(`companies/${companyId}/cases`, null, casesQuery);
  const { data: monthlyValuations, loading: valuationsLoading, error: valuationsError } = useFetchData(`companies/${companyId}/monthly-valuations`, null, valuationsQuery);
  const [averageCustomerRating, setAverageCustomerRating] = useState(null);
  const formatMonthYear = (date) => {
    return `${date.getMonth() + 1}-${date.getFullYear()}`;
  };
  const formattedMonth = formatMonthYear(selectedStartDate);
  const selectedMonthAverageRating = averageRatings[formattedMonth];
  useEffect(() => {
    if (workerCases && workerCases.length > 0) {
      const grouped = groupCasesByMonth(workerCases);
      setGroupedCases(grouped);
      const averages = calculateAverageRatingsByMonth(grouped);
      setAverageRatings(averages);

    }
  }, [workerCases]);
  
  const handleDateChange = (startDate, endDate) => {
    setSelectedStartDate(new Date(startDate));
    setSelectedEndDate(new Date(endDate));
  };
  const selectedMonthCases = useMemo(() => {
    const formattedMonth = formatMonthYear(selectedStartDate);
    return groupedCases[formattedMonth] || [];
  }, [groupedCases, selectedStartDate]);
  
  
  useEffect(() => {
    const formattedMonth = formatMonthYear(selectedStartDate);
    const monthRatings = averageRatings[formattedMonth];
  
    if (monthRatings) {
      setAverageCustomerRating(monthRatings);
    } else {
      setAverageCustomerRating("No ratings available");
    }
  }, [averageRatings, selectedStartDate]);
  

  if (casesLoading || valuationsLoading) {
    return <LoadingComponent />;
  }
  if (casesError || valuationsError) return <div>Error: {casesError || valuationsError}</div>;


  const renderRatingsAndQuestions = (ratings, questions) => {
    const averageRating = ratings.reduce((acc, curr) => acc + curr, 0) / ratings.length;
  
    return (
      <div className="worker-ratings-questions-container">
        {ratings.map((rating, index) => (
          <div className="worker-ratings-questions" key={index}>
            <div><strong>Spørgsmål:</strong> {questions[index]}</div>
            <div><strong>Rating:</strong> {rating}</div>
          </div>
        ))}
        <div className="worker-average-rating">
          <strong>Gennemsnitlig Rating:</strong> {averageRating.toFixed(2)}
        </div>
      </div>
    );
  };
  return (
    <>
      <ValuateNavbar />
      <>
        {currentWorker ? (
          <div className="container worker-details-container">
            <h2 className='main-header'>Sager for {currentWorker.name}</h2>
            <div className="month-picker-container">
            <p className="month-text" style={{color:"#FD6925"}}>Vælg Måned</p>
            <MonthPicker
              selectedDate={new Date(selectedStartDate)}
              onDateChange={handleDateChange}
              currentDate={new Date()}
            />
          </div>
            {selectedMonthAverageRating && (
          <div className="average-customer-rating">
            <h3>Gennemsnitlig Kundevurdering for {currentWorker.name} i {formattedMonth} : {selectedMonthAverageRating}</h3>
          </div>
        )}
            <WorkerCasesList workerCases={selectedMonthCases} renderRatingsAndQuestions={renderRatingsAndQuestions} />
            <h2 className='main-header'>Månedlig intern evalueringer for {currentWorker.name}</h2>
            <WorkerValuationsList monthlyValuations={monthlyValuations} renderRatingsAndQuestions={renderRatingsAndQuestions} />
          </div>
        ) : (
          <div>Loading worker details...</div>
        )}
      </>
    </>
  );
};

export default WorkerDetailsPage;
